// extracted by mini-css-extract-plugin
export default {"container":"SportTeamJersey_container__lu5rz","jerseyContainer":"SportTeamJersey_jerseyContainer__D9dNf","teamName":"SportTeamJersey_teamName__t1JEa"};